import React from 'react';

const Card = ({ children, styles }) => {
  return (
    <div
      style={{
        minHeight: 200,
        minWidth: 300,
        maxWidth: '400px',
        backgroundColor: '#f7f7f7',
        boxShadow:
          'rgba(0, 0, 0, 0.2) 0px 1px 1px, rgba(0, 0, 0, 0.1) 0px 9px 10px',
        ...styles
      }}
    >
      {children}
    </div>
  );
};
export default Card;
